import { Routes } from '@angular/router';
import { ProductProtocol } from './enums/protocol.enum';
import { guestGuard } from './guards/auth.guard';

export const routes: Routes = [
  // Public product pages (QR code destinations)
  { path: 'b/:id', loadComponent: () => import('./components/product-info/product-info').then(m => m.ProductInfo), data: { protocol: ProductProtocol.BLE } },
  { path: 'e/:id', loadComponent: () => import('./components/product-info/product-info').then(m => m.ProductInfo), data: { protocol: ProductProtocol.ENO } },
  { path: 'z/:id', loadComponent: () => import('./components/product-info/product-info').then(m => m.ProductInfo), data: { protocol: ProductProtocol.ZGP } },

  // Preview route (renders product template with mock device data)
  { path: 'preview/:partNumber', loadComponent: () => import('./components/product-info/product-info').then(m => m.ProductInfo), data: { isPreview: true } },

  // Authentication routes
  { path: 'login', loadComponent: () => import('./components/auth/login.component').then(m => m.LoginComponent), canActivate: [guestGuard] },
  { path: 'signup', loadComponent: () => import('./components/auth/signup.component').then(m => m.SignupComponent), canActivate: [guestGuard] },
  { path: 'forgot-password', loadComponent: () => import('./components/auth/forgot-password.component').then(m => m.ForgotPasswordComponent), canActivate: [guestGuard] },

  // Protected routes
  { path: 'unauthorized', loadComponent: () => import('./components/auth/unauthorized.component').then(m => m.UnauthorizedComponent) },

  // Admin routes (lazy loaded) — also serves as the post-login landing
  // for all roles. Mfg users get deep-linked from login to their hub.
  {
    path: "admin",
    loadChildren: () => import("./admin/admin.routes").then((m) => m.ADMIN_ROUTES),
  },

  // Redirects
  { path: 'dashboard', redirectTo: 'admin' },
  { path: '', redirectTo: 'admin', pathMatch: 'full' },
  { path: '**', redirectTo: 'https://adhocelectronics.com' }
];
